import templateOne from '@/assets/images/microsite-template-1.png';
import templateTwo from '@/assets/images/microsite-template-2.png';
import templateThree from '@/assets/images/microsite-template-3.png';

const micrositeTemplateTypesData = [
    {
      id: 'FRAMEBASE_TEMPLATE',
      name: 'Framebase Template',
      image: templateOne,
      description: 'A clean and modern layout with emphasis on visuals.'
    },
    {
      id: 'SITECRAFT_TEMPLATE',
      name: 'Sitecraft Template',
      image: templateTwo,
      description: 'A vibrant and colorful design with dynamic elements.'
    },
    {
      id: 'FLOWKIT_TEMPLATE',
      name: 'Flowkit Template',
      image: templateThree,
      description: 'A minimalist and elegant template focusing on content.'
    }
  ];

  export default micrositeTemplateTypesData;